import { SortableHeader } from '@/components/search/SortableHeader'
import './List.css'

import React, { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { useNavigate } from 'react-router-dom'
import { StaticPaginatedTable, StaticPaginatedTableState } from '@/components/search/StaticPaginatedTable'

import { User } from '@/services/repository/users'
import { SearchInput } from '@/components/search/SearchInput'
import { Translates } from '@/services/repository/i18n'

export const UserDashboardList = ({ services, session, data, selected, onSelect, parentState, setParentState, translates }: {
  services: Services
  session: CurrentSession
  data: User[] | undefined
  selected: User | undefined
  onSelect: (row: User | undefined) => void
  parentState: StaticPaginatedTableState
  setParentState: Dispatch<SetStateAction<StaticPaginatedTableState>>
  translates: Translates
}) => {
  const navigate = useNavigate()
  const [filtred, setFiltred] = useState(data)
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  useEffect(() => {
    if (!debouncedSearch || debouncedSearch === '') {
      setFiltred(data)
      return
    }
    setFiltred(data?.filter((u) => {
      return u.username.indexOf(debouncedSearch) >= 0
    }))
  }, [debouncedSearch])

  if (data === undefined) {
    return <div className='spinner'></div>
  }

  return <div className='communal-userstatistic-list'>
    <SearchInput translates={translates} value={search} onChange={setSearch} onDebouncedChange={setDebouncedSearch} />
    <StaticPaginatedTable<User>
      sortValues={{
        username: row => row.username
      }}
      data={filtred || []}
      parentState={parentState}
      setParentState={setParentState}
      header={(query, onSort) => <>
        <SortableHeader field='username' query={query} onSort={onSort}>{session.translates.for('elements.table.users.username')}</SortableHeader>
      </>}
      row={(row) => {
        const selectUser = () => {
          onSelect(row)
        }
        const isSelected = selected !== undefined && row.id === selected?.id
        const selectedClass = isSelected ? 'col-selected' : 'col-unselected'
        return <>
          <div className={`col ${selectedClass}`} onClick={selectUser}>{row.username}</div>
        </>
      }}
      translates={session.translates}
    />
  </div>
}

